import { useState } from 'react'
import { getAccountInitial } from '@/services/accounts'

interface AccountAvatarProps {
  account: {
    username: string
    display_name?: string
    profile_image_url?: string
  }
  dimmed?: boolean
}

/**
 * Account profile image with a neutral fallback so broken or stale image
 * URLs (common after disconnects and handle changes) never render as a
 * broken-image glyph.
 */
export function AccountAvatar({ account, dimmed = false }: AccountAvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null)
  const name = account.display_name || `@${account.username}`
  const src = account.profile_image_url
  const showImage = src && src !== failedSrc

  if (!showImage) {
    return (
      <span
        role="img"
        aria-label={`${name} avatar`}
        className={`w-12 h-12 shrink-0 rounded-full bg-secondary-bg border border-border flex items-center justify-center text-secondary-text font-medium ${dimmed ? 'opacity-70' : ''}`}
      >
        {getAccountInitial(account)}
      </span>
    )
  }

  return (
    <img
      src={src}
      alt={`${name} avatar`}
      onError={() => setFailedSrc(src)}
      className={`w-12 h-12 shrink-0 rounded-full ${dimmed ? 'opacity-70' : ''}`}
    />
  )
}
